var map = {
	"./BSS_hotkeys.json": 707,
	"./Cyberpunk_hotkeys.json": 708,
	"./DBS_hotkeys.json": 709,
	"./Digimon_hotkeys.json": 710,
	"./FAB_hotkeys.json": 711,
	"./FF_hotkeys.json": 712,
	"./Gundam_hotkeys.json": 713,
	"./Lorcana_hotkeys.json": 714,
	"./Magic_hotkeys.json": 715,
	"./OnePiece_hotkeys.json": 716,
	"./Pokemon_hotkeys.json": 717,
	"./Riftbound_hotkeys.json": 718,
	"./SWU_hotkeys.json": 719,
	"./Sorcery_hotkeys.json": 720,
	"./Vanguard_hotkeys.json": 721,
	"./WS_hotkeys.json": 722,
	"./YuGiOh_hotkeys.json": 723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 706;